import { ReactComponent as CloseDialog } from 'assett/icons/close_dialog_icon.svg';
import SelectGeneric from 'components/commons/form/SelectGeneric';
import UploadFileTile from 'components/UploadFile/UploadFileTile';
import {
	getClaimDetails,
	resetReturnAttachment,
	returnClaim,
} from 'feature/claims/claimSlice';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'store/store';
import { Button, Dialog, IconButton, Stack, Typography } from 'styles';
import { useTranslation } from 'utils/translations';

const ClaimReturn = () => {
	const { t: tClientLabels } = useTranslation('', {
		keyPrefix: 'clientLabels',
	});
	const { t: tDbLabels } = useTranslation('', {
		keyPrefix: 'dbLabels',
	});
	const dispatch = useDispatch<AppDispatch>();
	const { claimData, reasonCodesReturn, triggerRefresh } = useSelector(
		(store: RootState) => store.claim,
	);
	const [open, setOpen] = useState(false);
	const [reasonCode, setReasonCode] = useState('');

	const enableReturn = !!reasonCode && !!claimData.attachments.return;

	const handleOpen = () => {
		setOpen(true);
	};

	const handleClose = () => {
		setOpen(false);
		setReasonCode('');
		dispatch(resetReturnAttachment());
	};

	const handleReturnClaim = () => {
		dispatch(
			returnClaim({
				reasonCode,
			}),
		);
		setOpen(false);
	};

	useEffect(() => {
		if (triggerRefresh) {
			dispatch(getClaimDetails({ claimUuid: claimData.claimUUID! }));
		}
	}, [claimData.claimUUID, dispatch, triggerRefresh]);

	return (
		<>
			<Button variant="contained" fullWidth={false} onClick={handleOpen}>
				{tClientLabels('claim.button.return')}
			</Button>

			<Dialog
				open={open}
				onClose={handleClose}
				title={tClientLabels('claim.button.return')}
				variant="dialog"
				actions={null}
				events={false}
				close={
					<IconButton onClick={handleClose}>
						<CloseDialog />
					</IconButton>
				}
				type={''}
			>
				<Stack justifyContent="space-between" height={'378px'}>
					<Typography variant="body">
						{tClientLabels('claim.return.description', {
							claimID: claimData.externalClaimId,
						})}
					</Typography>

					<SelectGeneric
						name="reasonCode"
						sx={{
							width: {
								sm: '310px',
								md: '335px',
							},
						}}
						items={reasonCodesReturn.map(el => ({
							value: el.code,
							text: tDbLabels(el.label),
						}))}
						action={setReasonCode}
					/>

					<UploadFileTile
						label={tClientLabels('claim.return.fileUploaded')}
						labelUpload={tClientLabels('claim.return.uploadFile')}
						documentType={'return'}
						data={claimData.attachments?.return}
					/>
				</Stack>
				<Stack flexDirection={'row'} width={'100%'} justifyContent={'flex-end'}>
					<Button
						variant="contained"
						disabled={!enableReturn}
						onClick={handleReturnClaim}
					>
						{tClientLabels('claim.button.return')}
					</Button>
				</Stack>
			</Dialog>
		</>
	);
};

export default ClaimReturn;
